import { render, staticRenderFns } from "./td-Color.vue?vue&type=template&id=bbda5be6&"
import script from "./td-Color.vue?vue&type=script&lang=js&"
export * from "./td-Color.vue?vue&type=script&lang=js&"
import style0 from "./td-Color.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/oem/work/Rails/tosdere_erp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('bbda5be6', component.options)
    } else {
      api.reload('bbda5be6', component.options)
    }
    module.hot.accept("./td-Color.vue?vue&type=template&id=bbda5be6&", function () {
      api.rerender('bbda5be6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/packs/components/utils/comps/td-Color.vue"
export default component.exports